import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_URL, tempURl, windowURL } from "../url";
import { useAuth } from "../Context/AuthContext";

export default function MicrosoftSuccess() {
  const navigate = useNavigate();
  const { loginWithMicrosoft } = useAuth();

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) return navigate("/");

    localStorage.setItem("token", token);
    localStorage.setItem("isMicrosoftUser", "true");

    axios
      .get(`${tempURl}/auth/userinfo?token=${token}`)
      .then((res) => {
        loginWithMicrosoft(res.data);
        navigate("/home");
      })
      .catch(() => navigate("/"));
  }, []);

  return <p>Signing you in…</p>;
}
